<button
  mat-button
  class="dn-btn"
  color="primary"
  [disabled]="disabled"
  [ngClass]="{'disabled': disabled , 'large': size === 'large'  || !size, 'medium': size === 'medium', 'small': size === 'small'}"
  (click)="onClick($event)"> {{text}}</button>
